type StyleVars = {
  bg?: string;
  padding?: { top?: string; right?: string; bottom?: string; left?: string; unit?: string };
  radius?: number;
  button?: { bg?: string; text?: string; bgHover?: string; textHover?: string };
  leaveButton?: { bg?: string; text?: string; bgHover?: string; textHover?: string };
  notice?: { successBg?: string; successText?: string; errorBg?: string; errorText?: string };
  icon?: { successColor?: string; successBg?: string };
};

const setVar = (el: HTMLElement, key: string, val?: string | number) => {
  if (val === undefined || val === null) return;
  el.style.setProperty(key, String(val));
};

export function applyStyleVars(el: HTMLElement, styles?: StyleVars) {
  if (!el || !styles) return;
  setVar(el, '--ips-waitlist-bg', styles.bg);
  const unit = styles.padding?.unit || 'px';
  setVar(el, '--ips-waitlist-pad-top', (styles.padding?.top || '0') + unit);
  setVar(el, '--ips-waitlist-pad-right', (styles.padding?.right || '0') + unit);
  setVar(el, '--ips-waitlist-pad-bottom', (styles.padding?.bottom || '0') + unit);
  setVar(el, '--ips-waitlist-pad-left', (styles.padding?.left || '0') + unit);
  setVar(el, '--ips-waitlist-radius', styles.radius ?? '');

  if (styles.button) {
    setVar(el, '--ips-waitlist-btn-bg', styles.button.bg);
    setVar(el, '--ips-waitlist-btn-text', styles.button.text);
    setVar(el, '--ips-waitlist-btn-bg-hover', styles.button.bgHover);
    setVar(el, '--ips-waitlist-btn-text-hover', styles.button.textHover);
  }
  if (styles.leaveButton) {
    setVar(el, '--ips-waitlist-leave-bg', styles.leaveButton.bg);
    setVar(el, '--ips-waitlist-leave-text', styles.leaveButton.text);
    setVar(el, '--ips-waitlist-leave-bg-hover', styles.leaveButton.bgHover);
    setVar(el, '--ips-waitlist-leave-text-hover', styles.leaveButton.textHover);
  }
  if (styles.notice) {
    setVar(el, '--ips-waitlist-notice-success-bg', styles.notice.successBg);
    setVar(el, '--ips-waitlist-notice-success-text', styles.notice.successText);
    setVar(el, '--ips-waitlist-notice-error-bg', styles.notice.errorBg);
    setVar(el, '--ips-waitlist-notice-error-text', styles.notice.errorText);
  }
  if (styles.icon) {
    setVar(el, '--ips-waitlist-icon-success', styles.icon.successColor);
    setVar(el, '--ips-waitlist-icon-success-bg', styles.icon.successBg);
  }
}
